// Tip visual: Oil pool surface
// Animated ripple displacement on a flat plane

uniform float uTime;
varying vec2  vUv;
varying float vElevation;

void main() {
    vec3 pos = position;

    float e = sin(pos.x * 4.2 + uTime * 1.6) * 0.065
            + sin(pos.y * 3.4 - uTime * 1.1) * 0.048
            + sin((pos.x + pos.y) * 2.8 + uTime * 0.85) * 0.038;

    pos.z     += e;
    vElevation = e;
    vUv        = uv;

    gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
}
